export const ADD_CONTENT_FRAGMENT = 'ADD_CONTENT_FRAGMENT';
export const addContentFragment = (fragment, step) =>{
  return {
    type: ADD_CONTENT_FRAGMENT,
    fragment,
    step
  }
};

export const ERROR_CONTENT_FRAGMENT = 'ERROR_CONTENT_FRAGMENT';
export const errorContentFragment = () =>{
  return {
    type: ERROR_CONTENT_FRAGMENT
  }
};
